import { Component, Input, OnInit, HostListener } from '@angular/core';
import { ModalService } from './modal.service';

@Component({
    selector: 'app-modal',
    styleUrls: ['./modal.scss'],
    template: `
      <div [ngClass]="{'closed': !isOpen}">
        <div class="modal-overlay" (click)="close(true)"></div>

        <div class="modalaa">
         <!-- // <div  *ngIf="modalTitle"> -->
         <!--  <div  *ngIf="modalTitle !='Delete Product' ">-->
         <!--     <div class="title" >-->
         <!--   <span class="title-text">{{ modalTitle }}</span>-->
         <!-- //  <span class="right-align" (click)="close(true)"><i class="material-icons md-24">clear</i></span> -->
         <!--   </div>-->
         <!--  </div>-->

      <!-- <div  >
         <div class="titlegrey" >
            <span class="title-text">{{ modalTitle }}</span>
         </div>
       </div>-->

    <div  *ngIf="modalTitle =='Unos novog podatka'">
         <!--<div class="titlegreen" >-->
         <div class="titlegrey" >
           <span class="title-text">{{ modalTitle }}</span>
           <!--  <span class="right-align" (click)="close(true)"><i class="material-icons md-24">clear</i></span> -->
           </div>
     </div>

     <div  *ngIf="modalTitle =='Promjena podatka'">
         <div class="titlegrey" >
            <span class="title-text">{{ modalTitle }}</span>
           <!--  <span class="right-align" (click)="close(true)"><i class="material-icons md-24">clear</i></span> -->
         </div>
     </div>

   <div  *ngIf="modalTitle =='Brisanje podatka'">
         <!-- <div class="titlered" >-->
         <div class="titlegrey" >
            <span class="title-text">{{ modalTitle }}</span>
           <!--  <span class="right-align" (click)="close(true)"><i class="material-icons md-24">clear</i></span> -->
          </div>
     </div>
     
          <div class="body">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    `
})
export class ModalComponent implements OnInit {
  @Input() modalId: string;
  @Input() modalTitle: string;
  @Input() blocking = false;
  isOpen = false;

  @HostListener('keyup') onMouseEnter(event) {
    this.keyup(event);
  }

  constructor(private modalService: ModalService) {
  }

  ngOnInit() {
    this.modalService.registerModal(this);
  }

  close(checkBlocking = false): void {
    this.modalService.close(this.modalId, checkBlocking);
  }

  private keyup(event: KeyboardEvent): void {
    // if (event.keyCode === 27) {
     //  this.modalService.close(this.modalId, true);
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/modal/modal.component.ts